import React from 'react';

const Button = ({ onClick, children, disabled, className, type = "button" }) => {
    return (
        <button
            type={type}
            className={`rounded-btn text-center md:text-[20px] inline-flex items-center justify-center tracking-[2px] md:tracking-[10px] ${className}`}
            onClick={onClick}
            disabled={disabled}
        >

                <span className='inline-block translate-x-[1px] md:translate-x-[5px]'>{children}</span>

        </button>
    );
};

export default Button;

